import { useMutation } from '@tanstack/react-query';
import { getCategorySuggestions } from '@/services/categoryService';

export const useMutateCategoriesSuggestions = () => {
	return useMutation({
		mutationFn: getCategorySuggestions
	});
};
